module.exports = __webpack_public_path__ + "static/media/david.47d7c1dc.jpeg";